import type { IconSvgObject } from './types';

const TextColorIcon: IconSvgObject = [
  ["path", { d: "M3 21H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18.5 18L13.3443 3.93888C13.1375 3.37493 12.6007 3 12 3C11.3993 3 10.8625 3.37493 10.6557 3.93888L5.5 18M7.5 13H16.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default TextColorIcon;
